export default __webpack_public_path__ + "static/media/83.11abb7f7.png";